import { ImageUpload, ImageUploadProps } from '@makyoapp/makyo-tw-ui'

export type CompImageUploadProps = ImageUploadProps

/**
 * CompImageUploadCore
 */
export const CompImageUploadCore = (props: ImageUploadProps) => {
  return <ImageUpload {...props} />
}
